export const css = {
	underlayVisible: 'kNJyoq-G',
	' _key': 'certwise-theme/dojo/popup'
};

export default css;
